module.exports = __webpack_public_path__ + "img/5D.72e9c41c.png";